import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaFilm,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const BestVideoProductionServicesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Best Video Production Services in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Elevate Your Brand</Subheading>}
        heading={
          <Heading>
            Best <span tw="text-primary-500">Video Production Services</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer top-tier video production services in
            **Al Barsha**, delivering visually stunning and impactful videos
            that captivate audiences and elevate your brand. Create content that
            stands out with our expert team.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1601506521937-0121a7fc2a6b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1578302758063-0ef3e048ca89?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Project"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Video Production in Al Barsha"
        description="We craft videos with creativity and professionalism at the core."
        cards={[
          {
            icon: <FaFilm color="#ff5464" size={40} />,
            title: "Cinematic Quality",
            description: "High-definition visuals with a professional touch.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description: "Compelling narratives that resonate with audiences.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Timely delivery without compromising quality.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for web, mobile, and social media.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for video production.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full-Service Production",
            description: "From concept to final edit, we’ve got you covered.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Professional Video Production Process"
        description={
          <Description>
            We create impactful videos with a streamlined approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your vision and goals.</li>
              <li>Scripting: Craft a compelling storyline.</li>
              <li>Filming: Capture high-quality footage.</li>
              <li>Editing: Polish with effects, sound, and transitions.</li>
              <li>Review: Ensure the final product meets your expectations.</li>
              <li>Delivery: Provide ready-to-use video content.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1582152629442-4a864303fb96?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1509281373149-e957c6296406?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1570727624862-3008fe67a6be?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Video Production Wins in Al Barsha"
        description="Our videos have transformed brand narratives."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaign",
            description: "Drove 10x engagement for a local brand.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Brand Visibility",
            description: "Increased reach for an Al Barsha business.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from our clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Stunning Videos?</Subheading>}
        heading="Best Video Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional video production
            services in Al Barsha. Get high-quality, engaging videos that
            elevate your brand—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1524658751880-16a600520565?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1605130284535-11dd9eedc58a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
          "https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
